export default __webpack_public_path__ + "static/media/1.61e0c23f.jpg";